import React from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { AU_DESKTOP_EVENTS, DESKTOP_EVENT_ACTION } from "../../../tracking/au.desktop-events";
import { trackDesktopCustomEventsAU } from "../../../tracking";
import LazyImage from "../../shared/lazy-image";
import Logo from "../../shared/logo";
import SocialIcon from "../../shared/icon-social";
import { appUrl, cmsURl } from "../../../constants/url-constants";
import { getPageSectionByName } from "../../../utils/helpers/get-cms-section";
import {
    COUNTRY,
    DOWNLOAD_APP_URL_FOOTER,
    SELL_CAR_SEO_MENU,
    FOOTER_GEOS,
    SOCIAL_MEDIA_DATA,
    SOCIAL_MEDIA_KEYS,
    NUMBER,
    CORPORATE_ADDRESS,
    WEB_FOOTER_SECTION
} from "../../../constants/app-constants";

const Footer = ({
    isLoggedIn,
    seoMenu,
    cmsConfig
}) => {
    const trackEvent = (e, type = "social", label) => {
        const events = { action: "", params: "" };
        switch (type) {
        case "social":
            events.action = DESKTOP_EVENT_ACTION.SOCIAL_MEDIA;
            events.params = `options ${e ? e.target.innerText : label}`;
            break;
        case "links":
            events.action = DESKTOP_EVENT_ACTION.USEFUL_LINKS;
            events.params = `Link selected ${e ? e.target.innerText : label}`;
            break;
        default: events.action = "";
        }
        trackDesktopCustomEventsAU(events.action, { eventLabel: events.params });
    };

    const trackEventC2b = (e) => {
        const events = { action: "", params: "" };

        events.action = DESKTOP_EVENT_ACTION.SELL_CAR_LINKS;
        events.params = e.target.innerText;

        trackDesktopCustomEventsAU(events.action, { eventLabel: events.params });
    };

    const handleIos = () => {
        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.DOWNLOAD_APP_FOOTER, { eventLabel: "ios_download" });
    };

    const handlePlay = () => {
        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.DOWNLOAD_APP_FOOTER, { eventLabel: "android_download" });
    };

    const { cityTypeUrl = [] } = seoMenu || {};

    const footerSection = getPageSectionByName(cmsConfig?.pageSections, WEB_FOOTER_SECTION);
    const corporateAddress = footerSection?.meta?.address || CORPORATE_ADDRESS;

    const locationLinks = (cityTypeUrl || []).slice(0, NUMBER.THREE);
    const locationItems = locationLinks.length ? locationLinks : SELL_CAR_SEO_MENU.slice(0, NUMBER.THREE);
    const socialIconNameMap = {
        Instagram: SOCIAL_MEDIA_KEYS.INSTAGRAM,
        Facebook: SOCIAL_MEDIA_KEYS.FACEBOOK,
        LinkedIn: SOCIAL_MEDIA_KEYS.LINKEDIN,
        Twitter: SOCIAL_MEDIA_KEYS.X,
        X: SOCIAL_MEDIA_KEYS.X,
        YouTube: SOCIAL_MEDIA_KEYS.YOUTUBE,
        Youtube: SOCIAL_MEDIA_KEYS.YOUTUBE
    };
    const usefulLinks = [
        {
            label: "Find a car",
            to: `${appUrl()}/buy-used-cars-${COUNTRY.slug}/`,
            external: true,
            target: "_self",
            trackLabel: "find_a_car"
        },
        {
            label: "Apply for pre-approval",
            to: isLoggedIn ? "/my-account/financing/" : "/financing/get-pre-approval/",
            trackLabel: "financing"
        },
        {
            label: "Cars24 Finance",
            to: "/cars24-finance/",
            trackLabel: "cars24_finance",
            external: true
        },
        {
            label: "Careers",
            to: "https://apply.workable.com/cars24/?lng=en",
            external: true,
            trackLabel: "career"
        },
        {
            label: "The Cars24 Way",
            to: "/thecars24way/",
            trackLabel: "CARS24_way"
        },
        {
            label: "About Us",
            to: "/about-us/",
            trackLabel: "about_us"
        },
        {
            label: "Contact Us",
            to: "/contact-us/",
            trackLabel: "contact_us"
        },
        {
            label: "Warranty",
            to: "/cars24cover/",
            trackLabel: "warranty"
        },
        {
            label: "User Reviews",
            to: "/reviews/",
            trackLabel: "reviews"
        },
        {
            label: "Blog",
            to: `${cmsURl()}/blog/`,
            trackLabel: "blog",
            external: true
        }
    ];

    const informationLinks = [
        { label: "Privacy Policy", to: "/privacy-policy/" },
        { label: "Terms & Conditions", to: "/terms-of-use/" },
        { label: "Terms of Purchase", to: "/terms-of-purchase/" },
        { label: "Terms of Sale", to: "/terms-of-sale/" },
        { label: "FAQ", to: `${appUrl()}/faq/`, external: true }
    ];

    const flagIcons = {
        India: (
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
                <mask id="india-mask" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="2" width="20" height="16">
                    <path fillRule="evenodd" clipRule="evenodd" d="M0 6.05645C0 4.93634 0 4.37629 0.217987 3.94846C0.409734 3.57214 0.715695 3.26618 1.09202 3.07443C1.51984 2.85645 2.0799 2.85645 3.2 2.85645H16.8C17.9201 2.85645 18.4802 2.85645 18.908 3.07443C19.2843 3.26618 19.5903 3.57214 19.782 3.94846C20 4.37629 20 4.93634 20 6.05645V13.9423C20 15.0624 20 15.6224 19.782 16.0503C19.5903 16.4266 19.2843 16.7325 18.908 16.9243C18.4802 17.1423 17.9201 17.1423 16.8 17.1423H3.2C2.0799 17.1423 1.51984 17.1423 1.09202 16.9243C0.715695 16.7325 0.409734 16.4266 0.217987 16.0503C0 15.6224 0 15.0624 0 13.9423V6.05645Z" fill="white"/>
                </mask>
                <g mask="url(#india-mask)">
                    <path fillRule="evenodd" clipRule="evenodd" d="M0 12.3799H20V17.1418H0V12.3799Z" fill="#249F58"/>
                    <path fillRule="evenodd" clipRule="evenodd" d="M10.0001 12.3801C11.3144 12.3801 12.381 11.3134 12.381 9.99912C12.381 8.68483 11.3144 7.61816 10.0001 7.61816C8.68581 7.61816 7.61914 8.68483 7.61914 9.99912C7.61914 11.3134 8.68581 12.3801 10.0001 12.3801ZM10.0001 11.4277C10.7887 11.4277 11.4287 10.7877 11.4287 9.99912C11.4287 9.21055 10.7887 8.57055 10.0001 8.57055C9.21152 8.57055 8.57152 9.21055 8.57152 9.99912C8.57152 10.7877 9.21152 11.4277 10.0001 11.4277Z" fill="#1A47B8"/>
                    <path d="M9.99963 10.4753C10.2626 10.4753 10.4758 10.2621 10.4758 9.99914C10.4758 9.73615 10.2626 9.52295 9.99963 9.52295C9.73664 9.52295 9.52344 9.73615 9.52344 9.99914C9.52344 10.2621 9.73664 10.4753 9.99963 10.4753Z" fill="#1A47B8"/>
                    <path fillRule="evenodd" clipRule="evenodd" d="M0 2.85645H20V7.61835H0V2.85645Z" fill="#FF6C2D"/>
                </g>
            </svg>
        ),
        UAE: (
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
                <mask id="uae-mask" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="2" width="20" height="16">
                    <path fillRule="evenodd" clipRule="evenodd" d="M0 6.05645C0 4.93634 0 4.37629 0.217987 3.94846C0.409734 3.57214 0.715695 3.26618 1.09202 3.07443C1.51984 2.85645 2.0799 2.85645 3.2 2.85645H16.8C17.9201 2.85645 18.4802 2.85645 18.908 3.07443C19.2843 3.26618 19.5903 3.57214 19.782 3.94846C20 4.37629 20 4.93634 20 6.05645V13.9423C20 15.0624 20 15.6224 19.782 16.0503C19.5903 16.4266 19.2843 16.7325 18.908 16.9243C18.4802 17.1423 17.9201 17.1423 16.8 17.1423H3.2C2.0799 17.1423 1.51984 17.1423 1.09202 16.9243C0.715695 16.7325 0.409734 16.4266 0.217987 16.0503C0 15.6224 0 15.0624 0 13.9423V6.05645Z" fill="white"/>
                </mask>
                <g mask="url(#uae-mask)">
                    <path fillRule="evenodd" clipRule="evenodd" d="M0 12.3809H20V17.1428H0V12.3809Z" fill="#151515"/>
                    <path fillRule="evenodd" clipRule="evenodd" d="M0 2.85645H20V7.61835H0V2.85645Z" fill="#249F58"/>
                    <path fillRule="evenodd" clipRule="evenodd" d="M0 7.61816H20V12.3801H0V7.61816Z" fill="white"/>
                    <path fillRule="evenodd" clipRule="evenodd" d="M0 2.85645V17.1422H5.71429V2.85645H0Z" fill="#F93939"/>
                </g>
            </svg>
        )
    };

    const bottomCopyYear = new Date().getFullYear();

    return (
        <footer styleName={"styles.footer"}>
            <div styleName={"styles.footerCont"}>
                <div styleName={"styles.topRow"}>
                    <div styleName={"styles.leftSection"}>
                        <Logo type="iconWithText" colour="primary" width={"141px"} height={"40px"} />
                        <p styleName={"styles.heroHeading"}>Buy, Sell or Trade-in. All at one place!</p>
                        <p styleName={"styles.heroSubheading"}>Corporate office</p>
                        <p styleName={"styles.heroCopy"}>{corporateAddress}</p>
                        <div styleName={"styles.socialLinks"}>
                            {SOCIAL_MEDIA_DATA.map((item) => {
                                const iconName = socialIconNameMap[item.title] || SOCIAL_MEDIA_KEYS.FACEBOOK;

                                return (
                                    <a
                                        key={item.title}
                                        styleName={"styles.socialLink"}
                                        href={item.link}
                                        target="_blank"
                                        rel="noreferrer"
                                        onClick={(e) => trackEvent(e, "social")}
                                    >
                                        <SocialIcon name={iconName} shape="round" backgroundColor="#0F172B" size={32} />
                                    </a>
                                );
                            })}
                        </div>
                        <div styleName={"styles.storeLinks"}>
                            <a href={DOWNLOAD_APP_URL_FOOTER} onClick={handleIos} target="_blank" rel="noreferrer" styleName={"styles.storeLink"}>
                                <LazyImage
                                    src="https://fastly-production.24c.in/cars24/link_category_items/app-store.png"
                                    alt="Download on the App Store"
                                />
                            </a>
                            <a href={DOWNLOAD_APP_URL_FOOTER} onClick={handlePlay} target="_blank" rel="noreferrer" styleName={"styles.storeLink"}>
                                <LazyImage
                                    src="https://fastly-production.24c.in/cars24/link_category_items/play-store.png"
                                    alt="Get it on Google Play"
                                />
                            </a>
                        </div>
                    </div>
                    <div styleName={"styles.rightColumns"}>
                        <div styleName={"styles.column"}>
                            <p styleName={"styles.columnHeading"}>Used cars by location</p>
                            <ul styleName={"styles.columnList"}>
                                {locationItems.map((item) => (
                                    <li key={item?.label} styleName={"styles.columnListItem"}>
                                        <a href={`${appUrl()}/${item.spath}`} onClick={(e) => trackEvent(e, "links", item?.label)}>
                                            {item?.label}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div styleName={"styles.column"}>
                            <p styleName={"styles.columnHeading"}>Sell your car</p>
                            <ul styleName={"styles.columnList"}>
                                {SELL_CAR_SEO_MENU.map((item) => (
                                    <li key={item?.label} styleName={"styles.columnListItem"}>
                                        <a href={`${appUrl()}/${item.spath}`} onClick={trackEventC2b}>
                                            {item?.label}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div styleName={"styles.column"}>
                            <p styleName={"styles.columnHeading"}>Useful links</p>
                            <ul styleName={"styles.columnList"}>
                                {usefulLinks.map((link) => (
                                    <li key={link.label} styleName={"styles.columnListItem"}>
                                        {link.external ? (
                                            <a href={link.to} target={link.target || "_blank"} rel="noreferrer" onClick={() => trackEvent(null, "links", link.trackLabel)}>
                                                {link.label}
                                            </a>
                                        ) : (
                                            <Link to={link.to} onClick={() => trackEvent(null, "links", link.trackLabel)}>
                                                {link.label}
                                            </Link>
                                        )}
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div styleName={"styles.column"}>
                            <p styleName={"styles.columnHeading"}>Information</p>
                            <ul styleName={"styles.columnList"}>
                                {informationLinks.map((link) => (
                                    <li key={link.label} styleName={"styles.columnListItem"}>
                                        {link.external ? (
                                            <a href={link.to} target="_blank" rel="noreferrer" onClick={(e) => trackEvent(e, "links", link.label)}>
                                                {link.label}
                                            </a>
                                        ) : (
                                            <Link to={link.to} onClick={(e) => trackEvent(e, "links", link.label)}>
                                                {link.label}
                                            </Link>
                                        )}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
                <div styleName={"styles.bottomRow"}>
                    <p styleName={"styles.bottomText"}>
                        © {bottomCopyYear} Cars24 Services Private Limited ·{" "}
                        <a styleName={"styles.bottomLink"} href="https://www.cars24.com.au" target="_blank" rel="noreferrer">
                            www.cars24.com.au
                        </a>{" "}
                        · All rights reserved
                    </p>
                    <div styleName={"styles.globalBlock"}>
                        <span styleName={"styles.globalLabel"}>We are global</span>
                        <div styleName={"styles.flagList"}>
                            {FOOTER_GEOS.map((geo) => (
                                <a
                                    key={geo.title}
                                    href={geo.link}
                                    target="_blank"
                                    rel="noreferrer"
                                    styleName={"styles.flagLink"}
                                >
                                    <span styleName={"styles.flagIcon"}>{flagIcons[geo.title]}</span>
                                    <span styleName={"styles.flagLabel"}>{geo.title}</span>
                                </a>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

Footer.propTypes = {
    cmsConfig: PropTypes.object,
    selectedCityCode: PropTypes.number,
    isLoggedIn: PropTypes.bool,
    selectedCityName: PropTypes.string,
    reloadCarListConnect: PropTypes.func,
    resetCarListConnect: PropTypes.func,
    seoMenu: PropTypes.object,
    isSellYourCarPage: PropTypes.bool
};

export default Footer;
